import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamESES() {
  return (
    <div className={styles["declaration"]}>
      <h1>Declaración de Cumplimiento para la Capacitación y Evaluación del Personal de Campo en Canales de Venta</h1>

      <p>
        Para mejorar continuamente la calidad del servicio de los promotores externos en primera línea, el Equipo de Capacitación del Departamento Internacional de Xiaomi (en adelante, "nuestro equipo" o "nuestra empresa") ofrece cursos de capacitación y exámenes de refuerzo de conocimientos para los promotores externos en primera línea (en adelante, "participantes") designados por los proveedores de servicios externos. El objetivo de la capacitación y evaluación es mejorar el contenido del curso y consolidar los resultados del aprendizaje, y no constituye ninguna relación laboral ni comportamiento de gestión real. A continuación se detallan las declaraciones sobre la capacitación y evaluación:
      </p>

      <ol>
        <li>
          <strong>Naturaleza de la capacitación y evaluación</strong><br/>
          Todos los cursos y exámenes se realizan con el propósito de compartir conocimientos, ayudando a los participantes a comprender sistemáticamente la información del producto y los estándares de servicio. Los resultados de los exámenes solo reflejan el dominio del contenido por parte de los participantes y no deben usarse como base para evaluaciones de desempeño. No tenemos autoridad ni interferiremos en las evaluaciones de desempeño, distribución de salarios u otros asuntos laborales de los participantes por parte de los proveedores externos.
        </li>
        <li>
          <strong>Aclaración de la relación legal</strong><br/>
          La relación empleador-empleado entre los participantes y sus respectivos proveedores externos no se ve afectada por este programa. No hay relación laboral entre nuestra empresa y los participantes, ni este programa establece una relación de trabajo de facto.
        </li>
        <li>
          <strong>Uso de los resultados</strong><br/>
          Los resultados solo se utilizarán para:
          <ol type="1">
            <li>Optimización interna de nuestros cursos;</li>
            <li>Proporcionar a los proveedores externos prueba de la competencia profesional de los participantes, sujeto a su criterio independiente;</li>
            <li>Los resultados de los exámenes no serán públicos ni divulgados a terceros.</li>
          </ol>
        </li>
      </ol>

      <p>
        Esta declaración entra en vigor desde su publicación. La participación en el programa implica la aceptación de estos términos. Nos reservamos el derecho de interpretación y modificación.
      </p>

      <div className={styles["footer"]}>
        El Equipo de Capacitación del Departamento Internacional de Xiaomi<br/>
        Fecha: {getLocalizedTime('es-ES')}
      </div>
    </div>
  );
}